import styled from 'styled-components'

import COLORS from '@colors'

export const Container = styled.div`
  position: relative;
`

export const Popover = styled.div`
  background-color: ${COLORS.white};
  border-radius: 4px;
  box-shadow: 0 3px 6px #00000029;
  color: ${COLORS.gray45};
  height: ${props => (props.view ? 'auto' : '87px')};
  max-height: ${props => (props.view ? '125px' : '87px')};
  padding: ${props => (props.view ? '18px 12px' : '8px 0')};
  position: absolute;
  top: ${props => (props.view ? '-145px' : '-107px')};
  width: ${props => (props.view ? '144px' : '103px')};

  &:after {
    border-color: ${COLORS.white} transparent;
    border-style: solid;
    border-width: 10px 10px 0;
    bottom: -10px;
    content: '';
    display: block;
    left: 12px;
    position: absolute;
    width: 0;
    z-index: 1;
  }
`

export const Option = styled.div`
  align-items: center;
  color: ${COLORS.whiteA1};
  display: flex;
  height: 40px;
  padding: 0 8px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  outline: 0;

  &:hover {
    background-color: ${COLORS.whiteF3};
  }
`

export const Button = styled.div`
  background-color: ${props => (props.cancel ? COLORS.red : COLORS.white)};
  border: 0;
  border-radius: 4px;
  box-shadow: 0 3px 6px #00000029;
  color: ${props => (props.cancel ? COLORS.white : COLORS.gray45)};
  height: 32px;
  margin-right: ${props => (props.view || props.cancel ? '0' : '12px')};
  outline: 0;
  padding: ${props => (props.actionBtn ? '7px 8px' : '4px 8px')};
  width: ${props => {
    if (props.view) return '146px'
    if (props.actionBtn) return '100px'
    else return '180px'
  }};
  cursor: pointer;
  user-select: none;
  outline: 0;
  ${props => props.actionBtn && 'text-align: center;'}
`

export const LabelWrapper = styled.div`
  align-items: center;
  display: flex;

  p {
    line-height: 14px;
    padding: 4px 0;
  }
`

export const IconWrapper = styled.div`
  border-right: 1px solid ${COLORS.whiteA1};
  height: 24px;
  margin-right: 11px;
  padding-right: 8px;
`

export const ButtonContainer = styled.div`
  display: flex;
`
